/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MessageSquareDashed = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M3 6V5c0-1.1.9-2 2-2h2" }],
    ["path", { d: "M11 3h3" }],
    ["path", { d: "M18 3h1c1.1 0 2 .9 2 2" }],
    ["path", { d: "M21 9v2" }],
    ["path", { d: "M21 15c0 1.1-.9 2-2 2h-1" }],
    ["path", { d: "M14 17h-3" }],
    ["path", { d: "m7 17-4 4v-5" }],
    ["path", { d: "M3 12v-2" }]
  ]
];

export { MessageSquareDashed as default };
//# sourceMappingURL=message-square-dashed.js.map
